import Services from '@/utils/services'

const organizationDataSources = [1, 2, 101, 102, 103, 104, 999];
const infrastructureDataSources = [3, 4, 5, 6, 7, 8, 9, 10];
const allDataSources = organizationDataSources.concat(infrastructureDataSources);
const nationalPublicDataSources = [1];

const state = {
    isInitialized: false,
    updateBreadcrumbCount: 0,
    topLevelUnits: [],
    defaultUnitTreeOptions: [],
    privileges: [],
    syncPrivileges: [],
    assetTypes: [],
    assetSources: [],
    unitTypes: [],
    assetMutationCauses: [],
    assetMutationCauseTypes: [],
    assetMutationTypes: [],
    unitLevels: [],
    unitLevelsCentral: [],
    unitLevelsLocal: [],
    regions: [],
    assetCategories: [],
    tableComments: [],
    assetComments: [],
    assetTypeTrees: [],
    //assetModules: [],
    assetTypeGroups: [],
    reportConstants: {},
    reportRequestLoginUsers: [],
    syncDataSources: [],
    listMasterDataSyncTypes: [
        { id: 1, text: 'Danh mục đơn vị' },
        { id: 2, text: 'Danh mục loại đơn vị' },
        { id: 3, text: 'Danh mục cây tài sản' },
        { id: 4, text: 'Danh mục loại tài sản' },
        { id: 5, text: 'Danh mục nguồn hình thành tài sản' },
        { id: 6, text: 'Danh mục mục đích sử dụng' },
        { id: 7, text: 'Danh mục hiện trạng sử dụng' },
        { id: 8, text: 'Danh mục lý do tăng' },
        { id: 9, text: 'Danh mục lý do giảm' },
        { id: 10, text: 'Danh mục quốc gia' },
        { id: 11, text: 'Danh mục địa bàn' },
        { id: 12, text: 'Danh mục người dùng' },
        { id: 13, text: 'Danh mục hình thức xử lý' },
        { id: 14, text: 'Danh mục phương thức xử lý' },
        { id: 15, text: 'Danh mục dự án' },
        { id: 16, text: 'Danh mục bộ phận sử dụng' },
        { id: 17, text: 'Danh mục dùng chung Đơn vị sử dụng Ngân sách' },
        { id: 18, text: 'Danh mục dùng chung Mã tổ chức ngân sách, mã ngân sách toàn địa bàn' },
        { id: 19, text: 'Danh mục dùng chung Quốc gia' },
        { id: 20, text: 'Danh mục dùng chung Địa bàn hành chính' },
        { id: 21, text: 'Danh mục dùng chung Dự án đầu tư' },
        { id: 22, text: 'Danh mục dùng chung Các Ban quản lý dự án đầu tư' },
        { id: 23, text: 'Danh mục đối tác/ Nhà cung cấp/ Khách hàng' },
        { id: 24, text: 'Danh mục đơn vị uỷ thác' },
        { id: 25, text: 'Danh mục tuyến đường' },
        { id: 26, text: 'Danh mục nhãn hiệu' },
        { id: 27, text: 'Danh mục dòng sản phẩm' },
        { id: 28, text: 'Danh mục loại lý do biến động' },
        { id: 29, text: 'Danh mục lý do biến động' },
        { id: 30, text: 'Danh mục chức danh' },
        { id: 99, text: 'Danh mục dùng chung' },
        { id: 100, text: 'Danh mục hình thức mua sắm' }
    ],
    listAssetInfoSyncTypes: [
        { id: 1, text: 'Biến động tăng mới tài sản' },
        { id: 2, text: 'Biến động tăng nguyên giá tài sản' },
        { id: 3, text: 'Biến động giảm nguyên giá tài sản' },
        { id: 4, text: 'Biến động thay đổi thông tin tài sản' },
        { id: 5, text: 'Biến động giảm tài sản' },
        { id: 6, text: 'Biến động điều chuyển tài sản' },
        { id: 7, text: 'Kiểm kê tài sản' },
        { id: 8, text: 'Xử lý tài sản không đủ tiêu chuẩn' },
        { id: 9, text: 'Khấu hao tài sản' },
        { id: 10, text: 'Hao mòn tài sản' },
        { id: 11, text: 'Quyết định khai thác tài sản cho thuê' },
        { id: 12, text: 'Quyết định khai thác tài sản kinh doanh' },
        { id: 13, text: 'Quyết định khai thác tài sản liên doanh, liên kết' },
        { id: 14, text: 'Quyết định khai thác tài sản khác' },
        { id: 15, text: 'Chứng từ khai thác tài sản' },
        { id: 16, text: 'Quyết định tịch thu/ xác lập tài sản toàn dân' },
        { id: 17, text: 'Phương án xử lý tài sản toàn dân' },
        { id: 18, text: 'Kết quả xử lý tài sản toàn dân' },
        { id: 19, text: 'Danh sách thu chi xử lý tài sản toàn dân' },
        { id: 20, text: 'Tài sản theo Quyết định tịch thu/ xác lập tài sản toàn dân' },
        { id: 21, text: 'Tài sản theo Phương án xử lý tài sản toàn dân' }
    ],
    listReportSyncTypes: [
        {
            id: 1, title: 'Báo cáo mẫu 08a-ĐK/TSC (Phần 01)', shortName: '08a-ĐK/TSC (Phần 01)', text: 'Báo cáo mẫu 08a-ĐK/TSC (Phần 01) - Báo cáo tổng hợp hiện trạng sử dụng tài sản công', code: '08A_DK_TSC/08A_DK_TSC_01', table: 'RPT_08A_DK_TSC_01', unitTree: 1, syncSourceType: organizationDataSources, allowUnion: true, periodType: 1, unitCurrency: 0, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1
        },
        {
            id: 2, title: 'Báo cáo mẫu 08a-ĐK/TSC (Phần 02)', shortName: '08a-ĐK/TSC (Phần 02)', text: 'Báo cáo mẫu 08a-ĐK/TSC (Phần 02) - Báo cáo tổng hợp hiện trạng sử dụng tài sản công', code: '08A_DK_TSC/08A_DK_TSC_02', table: 'RPT_08A_DK_TSC_02', unitTree: 1, syncSourceType: organizationDataSources, allowUnion: true, periodType: 1, unitCurrency: 0, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1
        },
        {
            id: 3, title: 'Báo cáo mẫu 08a-ĐK/TSC (Phần 03)', shortName: '08a-ĐK/TSC (Phần 03)', text: 'Báo cáo mẫu 08a-ĐK/TSC (Phần 03) - Báo cáo tổng hợp hiện trạng sử dụng tài sản công', code: '08A_DK_TSC/08A_DK_TSC_03', table: 'RPT_08A_DK_TSC_03', unitTree: 1, syncSourceType: organizationDataSources, allowUnion: true, periodType: 1, unitCurrency: 0, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1, unitLevel: 1
        },
        {
            id: 4, title: 'Báo cáo mẫu 08b-ĐK/TSC (Phần 01)', shortName: '08b-ĐK/TSC (Phần 01)', text: 'Báo cáo mẫu 08b-ĐK/TSC (Phần 01) - Báo cáo tổng hợp tình hình tăng, giảm tài sản công', code: '08B_DK_TSC/08B_DK_TSC_01', table: 'RPT_08B_DK_TSC_01', unitTree: 1, syncSourceType: organizationDataSources, allowUnion: true, periodType: 2, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1
        },
        {
            id: 5, title: 'Báo cáo mẫu 08b-ĐK/TSC (Phần 02)', shortName: '08b-ĐK/TSC (Phần 02)', text: 'Báo cáo mẫu 08b-ĐK/TSC (Phần 02) - Báo cáo tổng hợp tình hình tăng, giảm tài sản công', code: '08B_DK_TSC/08B_DK_TSC_02', table: 'RPT_08B_DK_TSC_02', unitTree: 1, syncSourceType: organizationDataSources, allowUnion: true, periodType: 2, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1
        },
        {
            id: 6, title: 'Báo cáo mẫu 08b-ĐK/TSC (Phần 03)', shortName: '08b-ĐK/TSC (Phần 03)', text: 'Báo cáo mẫu 08b-ĐK/TSC (Phần 03) - Báo cáo tổng hợp tình hình tăng, giảm tài sản công', code: '08B_DK_TSC/08B_DK_TSC_03', table: 'RPT_08B_DK_TSC_03', unitTree: 1, syncSourceType: organizationDataSources, allowUnion: true, periodType: 2, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1, unitLevel: 1
        },

        {
            id: 7, title: 'Báo cáo mẫu 09a-CK/TSC', shortName: '09a-CK/TSC', text: 'Báo cáo mẫu 09a-CK/TSC - Báo cáo công khai tình hình đầu tư xây dựng, mua sắm, giao, thuê tài sản công', code: '09_CK_TSC/09A_CK_TSC', table: 'RPT_09A_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 0, assetTypeLevel: 0, assetTypeGroupId: 0
        },
        {
            id: 8, title: 'Báo cáo mẫu 09b-CK/TSC', shortName: '09b-CK/TSC', text: 'Báo cáo mẫu 09b-CK/TSC - Báo cáo công khai tình hình quản lý, sử dụng trụ sở làm việc, cơ sở hoạt động sự nghiệp', code: '09_CK_TSC/09B_CK_TSC', table: 'RPT_09B_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 0, assetTypeGroupId: 0
        },
        {
            id: 9, title: 'Báo cáo mẫu 09c-CK/TSC', shortName: '09c-CK/TSC', text: 'Báo cáo mẫu 09c-CK/TSC - Báo cáo công khai tình hình quản lý, sử dụng xe ô tô và tài sản cố định khác', code: '09_CK_TSC/09C_CK_TSC', table: 'RPT_09C_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 0, assetTypeLevel: 0, assetTypeGroupId: 0
        },
        {
            id: 10, title: 'Báo cáo mẫu 09d-CK/TSC', shortName: '09d-CK/TSC', text: 'Báo cáo mẫu 09d-CK/TSC - Báo cáo công khai tình hình xử lý tài sản công', code: '09_CK_TSC/09D_CK_TSC', table: 'RPT_09D_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 0, assetTypeLevel: 0, assetTypeGroupId: 0
        },
        {
            id: 11, title: 'Báo cáo mẫu 09đ-CK/TSC', shortName: '09đ-CK/TSC', text: 'Báo cáo mẫu 09đ-CK/TSC - Báo cáo công khai tình hình khai thác nguồn lực tài chính từ tài sản công', code: '09_CK_TSC/09DD_CK_TSC', table: 'RPT_09DD_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 0, assetTypeGroupId: 0
        },
        {
            id: 12, title: ' Báo cáo mẫu 10a-CK/TSC', shortName: '10a-CK/TSC', text: ' Báo cáo mẫu 10a-CK/TSC - Báo cáo công khai tình hình đầu tư xây dựng, mua sắm, giao, thuê tài sản công', code: '10_CK_TSC/10A_CK_TSC', table: 'RPT_10A_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1, unitLevel: 1
        },
        {
            id: 13, title: 'Báo cáo mẫu 10b-CK/TSC', shortName: '10b-CK/TSC', text: 'Báo cáo mẫu 10b-CK/TSC - Báo cáo công khai tình hình quản lý, sử dụng tài sản công', code: '10_CK_TSC/10B_CK_TSC', table: 'RPT_10B_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1, unitLevel: 1
        },
        {
            id: 14, title: ' Báo cáo mẫu 10c-CK/TSC', shortName: '10c-CK/TSC', text: 'Báo cáo mẫu 10c-CK/TSC - Báo cáo công khai tình hình xử lý tài sản công', code: '10_CK_TSC/10C_CK_TSC', table: 'RPT_10C_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1, unitLevel: 1
        },
        {
            id: 15, title: 'Báo cáo mẫu 10d-CK/TSC', shortName: '10d-CK/TSC', text: 'Báo cáo mẫu 10d-CK/TSC - Báo cáo công khai tình hình khai thác nguồn lực tài chính từ tài sản công', code: '10_CK_TSC/10D_CK_TSC', table: 'RPT_10D_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 1, unitLevel: 1
        },
        {
            id: 16, title: 'Báo cáo mẫu 11a-CK/TSC', shortName: '11a-CK/TSC', text: 'Báo cáo mẫu 11a-CK/TSC - Công khai tình hình đầu tư xây dựng, mua sắm, giao, thuê tài sản công', code: '11_CK_TSC/11A_CK_TSC', table: 'RPT_11A_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 0, assetTypeGroupId: 1, unitLevel: 0
        },
        {
            id: 17, title: 'Báo cáo mẫu 11b-CK/TSC', shortName: '11b-CK/TSC', text: 'Báo cáo mẫu 11b-CK/TSC - Công khai tình hình quản lý, sử dụng tài sản công', code: '11_CK_TSC/11B_CK_TSC', table: 'RPT_11B_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 0, unitArea: 1, assetTypeLevel: 0, assetTypeGroupId: 1, unitLevel: 0
        },
        {
            id: 18, title: 'Báo cáo mẫu 11c-CK/TSC', shortName: '11c-CK/TSC', text: 'Báo cáo mẫu 11c-CK/TSC - Công khai tình hình xử lý tài sản công', code: '11_CK_TSC/11C_CK_TSC', table: 'RPT_11C_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 0, assetTypeGroupId: 1, unitLevel: 0
        },
        {
            id: 19, title: 'Báo cáo mẫu 11d-CK/TSC', shortName: '11d-CK/TSC', text: 'Báo cáo mẫu 11d-CK/TSC - Công khai tình hình khai thác nguồn lực tài chính từ tài sản công', code: '11_CK_TSC/11D_CK_TSC', table: 'RPT_11D_CK_TSC', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 0, assetTypeGroupId: 1, unitLevel: 0
        },

        {
            id: 20, title: 'Báo cáo mẫu 08a-ĐK/TSKCHT (Phần 01)', shortName: '08a-ĐK/TSKCHT (Phần 01)', text: 'Báo cáo mẫu 08a-ĐK/TSKCHT (Phần 01) - Báo cáo tổng hợp tình hình quản lý tài sản kết cấu hạ tầng', code: '08A_DK_TSKCHT/08A_DK_TSKCHT_01', table: 'RPT_08A_DK_TSKCHT_01', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3
        },
        {
            id: 21, title: 'Báo cáo mẫu 08a-ĐK/TSKCHT (Phần 02)', shortName: '08a-ĐK/TSKCHT (Phần 02)', text: 'Báo cáo mẫu 08a-ĐK/TSKCHT (Phần 02) - Báo cáo tổng hợp tình hình quản lý tài sản kết cấu hạ tầng', code: '08A_DK_TSKCHT/08A_DK_TSKCHT_02', table: 'RPT_08A_DK_TSKCHT_02', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3
        },
        {
            id: 22, title: 'Báo cáo mẫu 08a-ĐK/TSKCHT (Phần 03)', shortName: '08a-ĐK/TSKCHT (Phần 03)', text: 'Báo cáo mẫu 08a-ĐK/TSKCHT (Phần 03) - Báo cáo tổng hợp tình hình quản lý tài sản kết cấu hạ tầng', code: '08A_DK_TSKCHT/08A_DK_TSKCHT_03', table: 'RPT_08A_DK_TSKCHT_03', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3, unitLevel: 1
        },
        {
            id: 23, title: 'Báo cáo mẫu 08b-ĐK/TSKCHT (Phần 01)', shortName: '08b-ĐK/TSKCHT (Phần 01)', text: 'Báo cáo mẫu 08b-ĐK/TSKCHT (Phần 01) - Báo cáo tổng hợp tình hình khai thác tài sản kết cấu hạ tầng', code: '08B_DK_TSKCHT/08B_DK_TSKCHT_01', table: 'RPT_08B_DK_TSKCHT_01', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3
        },
        {
            id: 24, title: 'Báo cáo mẫu 08b-ĐK/TSKCHT (Phần 02)', shortName: '08b-ĐK/TSKCHT (Phần 02)', text: 'Báo cáo mẫu 08b-ĐK/TSKCHT (Phần 02) - Báo cáo tổng hợp tình hình khai thác tài sản kết cấu hạ tầng', code: '08B_DK_TSKCHT/08B_DK_TSKCHT_02', table: 'RPT_08B_DK_TSKCHT_02', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3
        },
        {
            id: 25, title: 'Báo cáo mẫu 08b-ĐK/TSKCHT (Phần 03)', shortName: '08b-ĐK/TSKCHT (Phần 03)', text: 'Báo cáo mẫu 08b-ĐK/TSKCHT (Phần 03) - Báo cáo tổng hợp tình hình khai thác tài sản kết cấu hạ tầng', code: '08B_DK_TSKCHT/08B_DK_TSKCHT_03', table: 'RPT_08B_DK_TSKCHT_03', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3, unitLevel: 1
        },
        {
            id: 26, title: 'Báo cáo mẫu 08c-ĐK/TSKCHT (Phần 01)', shortName: '08c-ĐK/TSKCHT (Phần 01)', text: 'Báo cáo mẫu 08c-ĐK/TSKCHT (Phần 01) - Báo cáo tổng hợp tình hình xử lý tài sản kết cấu hạ tầng', code: '08C_DK_TSKCHT/08C_DK_TSKCHT_01', table: 'RPT_08C_DK_TSKCHT_01', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, handlingType: 1, assetTypeLevel: 1, assetTypeGroupId: 3
        },
        {
            id: 27, title: 'Báo cáo mẫu 08c-ĐK/TSKCHT (Phần 02)', shortName: '08c-ĐK/TSKCHT (Phần 02)', text: 'Báo cáo mẫu 08c-ĐK/TSKCHT (Phần 02) - Báo cáo tổng hợp tình hình xử lý tài sản kết cấu hạ tầng', code: '08C_DK_TSKCHT/08C_DK_TSKCHT_02', table: 'RPT_08C_DK_TSKCHT_02', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 3, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3
        },
        {
            id: 28, title: 'Báo cáo mẫu 08d-ĐK/TSKCHT', shortName: '08d-ĐK/TSKCHT', text: 'Báo cáo mẫu 08d-ĐK/TSKCHT - Báo cáo tổng hợp tình hình tăng, giảm tài sản kết cấu hạ tầng', code: '08D_DK_TSKCHT/08D_DK_TSKCHT', table: 'RPT_08D_DK_TSKCHT', unitTree: 1, syncSourceType: infrastructureDataSources, allowUnion: true, periodType: 2, unitCurrency: 1, unitArea: 1, assetTypeLevel: 1, assetTypeGroupId: 3
        },

        {
            id: 29, title: 'Báo cáo Chính phủ - Phụ lục I', shortName: 'BCCP - Phụ lục I', text: 'Báo cáo Chính phủ - Phụ lục I - Tổng hợp tài sản công', code: 'BCCP_TSC/BCCP_01_TSC', table: 'RPT_BCCP_01', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 30, title: 'Báo cáo Chính phủ - Phụ lục II', shortName: 'BCCP - Phụ lục II', text: 'Báo cáo Chính phủ - Phụ lục II - Cơ cấu tài sản công tại các cơ quan, tổ chức, đơn vị, ban quản lý dự án', code: 'BCCP_TSC/BCCP_02_TSC', table: 'RPT_BCCP_02', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 31, title: 'Báo cáo Chính phủ - Phụ lục III', shortName: 'BCCP - Phụ lục III', text: 'Báo cáo Chính phủ - Phụ lục III - Quỹ đất chia theo nhóm mục đích sử dụng', code: 'BCCP_TSC/BCCP_03_TSC', table: 'RPT_BCCP_03', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 32, title: 'Báo cáo Chính phủ - Phụ lục IV', shortName: 'BCCP - Phụ lục IV', text: 'Báo cáo Chính phủ - Phụ lục IV - Tổng hợp tài sản công chia theo loại tài sản', code: 'BCCP_TSC/BCCP_04_TSC', table: 'RPT_BCCP_04', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 33, title: 'Báo cáo Chính phủ - Phụ lục V', shortName: 'BCCP - Phụ lục V', text: 'Báo cáo Chính phủ - Phụ lục V - Tổng hợp giá trị tài sản công theo nhóm cơ quan, tổ chức, đơn vị, ban quản lý dự án', code: 'BCCP_TSC/BCCP_05_TSC', table: 'RPT_BCCP_05', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 34, title: 'Báo cáo Chính phủ - Phụ lục VI', shortName: 'BCCP - Phụ lục VI', text: 'Báo cáo Chính phủ - Phụ lục VI - Tổng hợp tài sản công theo cấp quản lý', code: 'BCCP_TSC/BCCP_06_TSC', table: 'RPT_BCCP_06', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 35, title: 'Báo cáo Chính phủ - Phụ lục VII', shortName: 'BCCP - Phụ lục VII', text: 'Báo cáo Chính phủ - Phụ lục VII - Xe ô tô theo mục đích sử dụng', code: 'BCCP_TSC/BCCP_07_TSC', table: 'RPT_BCCP_07', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 36, title: 'Báo cáo Chính phủ - Phụ lục VIII', shortName: 'BCCP - Phụ lục VIII', text: 'Báo cáo Chính phủ - Phụ lục VIII - Xe ô tô sử dụng vượt thời hạn quy định', code: 'BCCP_TSC/BCCP_08_TSC', table: 'RPT_BCCP_08', unitTree: 1, syncSourceType: allDataSources, periodType: 3, unitCurrency: 0, unitArea: 0
        },
        {
            id: 37, title: 'Báo cáo Chính phủ - Phụ lục IX', shortName: 'BCCP - Phụ lục IX', text: 'Báo cáo Chính phủ - Phụ lục IX - Tài sản cố định khác (ngoài đất, nhà, xe ô tô) theo mục đích sử dụng', code: 'BCCP_TSC/BCCP_09_TSC', table: 'RPT_BCCP_09', unitTree: 1, syncSourceType: allDataSources, periodType: 1, unitCurrency: 0, unitArea: 0
        },
        {
            id: 38, title: 'Báo cáo Chính phủ - Phụ lục X', shortName: 'BCCP - Phụ lục X', text: 'Báo cáo Chính phủ - Phụ lục X - Tổng hợp tình hình tăng, giảm tài sản công', code: 'BCCP_TSC/BCCP_10_TSC', table: 'RPT_BCCP_10', unitTree: 1, syncSourceType: allDataSources, periodType: 3, unitCurrency: 0, unitArea: 0
        },
        {
            id: 39, title: 'Báo cáo Chính phủ - Phụ lục XIa', shortName: 'BCCP - Phụ lục XIa', text: 'Báo cáo Chính phủ - Phụ lục XIa - Bảng tổng hợp tài sản công tại các cơ quan, tổ chức, đơn vị, ban quản lý dự án', code: 'BCCP_TSC/BCCP_11A_TSC', table: 'RPT_BCCP_11A', unitTree: 1, syncSourceType: allDataSources, periodType: 3, unitCurrency: 0, unitArea: 0
        },
        {
            id: 40, title: 'Báo cáo Chính phủ - Phụ lục XIb', shortName: 'BCCP - Phụ lục XIb', text: 'Báo cáo Chính phủ - Phụ lục XIb - Bảng tổng hợp tài sản công tại các cơ quan, tổ chức, đơn vị, ban quản lý dự án', code: 'BCCP_TSC/BCCP_11B_TSC', table: 'RPT_BCCP_11B', unitTree: 1, syncSourceType: allDataSources, periodType: 3, unitCurrency: 0, unitArea: 0
        },

        { id: 41, title: 'Báo cáo thống kê về hiện vật', text: 'Báo cáo thống kê về hiện vật', code: 'BCK_TSC/BCTKHV', table: 'RPT_BCTSCTKVHV', unitTree: 1, syncSourceType: organizationDataSources, periodType: 1, unitCurrency: 0, unitArea: 1 },
        {
            id: 42, title: 'Báo cáo mẫu B03/CCTT', shortName: 'B03/CCTT (Phần 01)', text: 'Báo cáo mẫu B03/CCTT - Tài sản cố định hữu hình trang bị cho đơn vị', code: 'BCK_TSC/BCK_B03_CCTT_A', table: 'RPT_B03_CCTT_A', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 0, administrativeLevel: 1
        },
        {
            id: 43, title: 'Báo cáo mẫu B03/CCTT', shortName: 'B03/CCTT (Phần 02)', text: 'Báo cáo mẫu B03/CCTT - Tài sản cố định vô hình trang bị cho đơn vị', code: 'BCK_TSC/BCK_B03_CCTT_B', table: 'RPT_B03_CCTT_B', unitTree: 1, syncSourceType: organizationDataSources, periodType: 3, unitCurrency: 1, unitArea: 0, administrativeLevel: 1
        },
        {
            id: 44, title: 'Báo cáo mẫu 01-BC/XLSHTD', shortName: '01-BC/XLSHTD', text: 'Báo cáo mẫu 01-BC/XLSHTD - Báo cáo kê khai thông tin tài sản được xác lập quyền sở hữu toàn dân', code: 'BCK_TSC/XLSHTD_01', table: 'RPT_XLSHTD_01', unitTree: 1, syncSourceType: nationalPublicDataSources, assetSource: 1, decisionNumber: 0, periodType: 1, unitCurrency: 1
        },
        {
            id: 45, title: 'Báo cáo mẫu 02-BC/XLSHTD-P1', shortName: '02-BC/XLSHTD (Phần 01)', text: 'Báo cáo mẫu 02-BC/XLSHTD-P1 - Báo cáo tổng hợp tình hình tăng, giảm tài sản được xác lập sở hữu toàn dân - Phần 1: Tổng hợp chung', code: 'BCK_TSC/XLSHTD_02_P1', table: 'RPT_XLSHTD_02_P1', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, assetSource: 1, periodType: 2, assetTypeLevel: 1/*, assetTypeGroupId: 2*/, unitCurrency: 1/*, unitArea: 1*/
        },
        {
            id: 46, title: 'Báo cáo mẫu 02-BC/XLSHTD-P2', shortName: '02-BC/XLSHTD (Phần 02)', text: 'Báo cáo mẫu 02-BC/XLSHTD-P2 - Báo cáo tổng hợp tình hình tăng, giảm tài sản được xác lập sở hữu toàn dân - Phần 2: Chi tiết từng đơn vị trực thuộc', code: 'BCK_TSC/XLSHTD_02_P2', table: 'RPT_XLSHTD_02_P2', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, assetSource: 1, periodType: 2, assetTypeLevel: 1/*, assetTypeGroupId: 2*/, unitCurrency: 1/*, unitArea: 1*/, unitLevel: 1
        },
        {
            id: 47, title: 'Báo cáo mẫu 03-BC/XLSHTD', shortName: '03-BC/XLSHTD', text: 'Báo cáo mẫu 03-BC/XLSHTD - Báo cáo tổng hợp tình hình tăng tài sản được xác lập sở hữu toàn dân', code: 'BCK_TSC/XLSHTD_03', table: 'RPT_XLSHTD_03', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, assetSource: 1, periodType: 2, assetTypeLevel: 1/*, assetTypeGroupId: 2*/, unitCurrency: 1
        },
        {
            id: 48, title: 'Báo cáo mẫu 04-BC/XLSHTD', shortName: '04-BC/XLSHTD', text: 'Báo cáo mẫu 04-BC/XLSHTD - Báo cáo tổng hợp tình hình giảm tài sản được xác lập sở hữu toàn dân', code: 'BCK_TSC/XLSHTD_04', table: 'RPT_XLSHTD_04', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, assetSource: 1, periodType: 2, assetTypeLevel: 1/*, assetTypeGroupId: 2*/, unitCurrency: 1
        },
        {
            id: 49, title: 'Báo cáo mẫu 05-BC/XLSHTD', shortName: '05-BC/XLSHTD', text: 'Báo cáo mẫu 05-BC/XLSHTD - Báo cáo tổng hợp số tiền thu được từ xử lý tài sản được xác lập sở hữu toàn dân', code: 'BCK_TSC/XLSHTD_05', table: 'RPT_XLSHTD_05', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, assetSource: 1, periodType: 2, assetTypeLevel: 1/*, assetTypeGroupId: 2*/, unitCurrency: 1
        },
        {
            id: 50, title: 'Báo cáo mẫu 06-BC/XLSHTD', shortName: '06-BC/XLSHTD', text: 'Báo cáo mẫu 06-BC/XLSHTD - Báo cáo tổng hợp tình hình giảm tài sản được xác lập sở hữu toàn dân', code: 'BCK_TSC/XLSHTD_06', table: 'RPT_XLSHTD_06', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, assetSource: 1, periodType: 2, assetTypeLevel: 1/*, assetTypeGroupId: 2*/, unitCurrency: 1
        },
        {
            id: 51, title: 'Báo cáo Biểu số 03 - BC/XLSHTD', shortName: '03-BC/XLSHTD (Biểu mới)', text: 'Báo cáo Biểu số 03-BC/XLSHTD - Báo cáo kê khai thông tin phương án xử lý tài sản được xác lập quyền sở hữu toàn dân', code: 'BCK_TSC/XLSHTD_07', table: 'RPT_XLSHTD_07', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, periodType: 2, assetSource: 1, unitCurrency: 1
        },
        {
            id: 52, title: 'Kết quả xử lý tài sản được xác lập sở hữu toàn dân', shortName: '04-BC/XLSHTD (Biểu mới', text: 'Kết quả xử lý tài sản được xác lập sở hữu toàn dân', code: 'BCK_TSC/XLSHTD_08', table: 'RPT_XLSHTD_08', unitTree: 1, syncSourceType: nationalPublicDataSources, allowUnion: true, periodType: 2, unitCurrency: 1
        },
        {
            id: 53, title: 'Báo cáo - BC/XLTSHT', shortName: 'BC/XLTSHT', text: 'Báo cáo BC/XLTSHT - Báo cáo tình hình xử lý tài sản kết cấu hạ tầng', code: 'BCK_TSC/XLTSHT_01', table: 'RPT_XLTSHT_01', unitTree: 1, syncSourceType: infrastructureDataSources, periodType: 1, unitCurrency: 0, unitArea: 1
        }
    ],
    listGroupReportTypes: [
        { id: 1, text: 'Báo cáo tổng hợp', code: 'summary', reportTypeIds: [1, 2, 3, 4, 5, 6, 20, 21, 22, 23, 24, 25, 26, 27, 28] },
        { id: 2, text: 'Báo cáo công khai', code: 'public', reportTypeIds: [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19] },
        { id: 3, text: 'Báo cáo Chính phủ', code: 'goverment', reportTypeIds: [29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40] },
        { id: 4, text: 'Báo cáo khác', code: 'other', reportTypeIds: [41, 42, 43, 53] },
        { id: 5, text: 'Báo cáo sở hữu toàn dân', code: 'national-asset-type', reportTypeIds: [44, 45, 46, 47, 48, 49, 50, 51, 52] },
    ],
    //loại tài sản sở hữu toàn dân
    listNationalAssetType: [],
    //bậc tài sản
    listReportAssetTypeLevel: [
        { id: 1, text: 'Bậc 1' },
        { id: 2, text: 'Bậc 2' },
        { id: 3, text: 'Bậc 3' },
        { id: 4, text: 'Bậc 4' },
        { id: 5, text: 'Bậc 5' }
    ],
    listReportUnitLevel: [
        { id: 1, text: 'Bậc 1' },
        { id: 2, text: 'Bậc 2' },
        { id: 3, text: 'Bậc 3' },
        { id: 4, text: 'Bậc 4' },
        { id: 5, text: 'Bậc 5' }
    ],
    inventoryForms: [
        { id: 1, text: 'Kiểm kê thường niên' },
        { id: 2, text: 'Kiểm kê đột xuất' },
        { id: 3, text: 'Kiểm kê tài sản dự án' },
        { id: 4, text: 'Kiểm kê khác' }
    ],
    inventoryStatuses: [
        { id: 1, text: 'Chờ duyệt' },
        { id: 2, text: 'Đã duyệt đang xử lý' },
        { id: 3, text: 'Đã xử lý xong' },
        { id: 4, text: 'Từ chối' },
        { id: 5, text: 'Đã hủy' }
    ],
    listStatuses: [
        { id: false, text: 'Thất bại' },
        { id: true, text: 'Thành công' }
    ],
    listStatusRequest: [
        { id: 1, text: 'Đã gửi' },
        { id: 2, text: 'Thành công', },
        { id: 3, text: 'Lỗi' }
    ],
    listActions: [
        { id: 1, text: 'Thêm mới' },
        { id: 2, text: 'Sửa' },
        //{ id: 3, text: 'Xóa' }
    ],
    listSyncSourceTypes: [
        //{ id: 1, text: 'Phần mềm QLTSC', assetTypeGroupId: 1, assetTypeGroupIds: [1, 2], assetInventory: true, syncDataSourceId: 1 },
        //{ id: 2, text: 'Các phần mềm QLTSC khác', assetTypeGroupId: 1, assetTypeGroupIds: [1], assetInventory: true, syncDataSourceId: 1 },
        ////{ id: 101, text: 'Phần mềm QLTSNN', assetTypeGroupId: 1, assetTypeGroupIds: [1], assetInventory: true, syncDataSourceId: 1 },
        ////{ id: 102, text: 'Phần mềm QLTSC (Đào tạo)', assetTypeGroupId: 1, assetTypeGroupIds: [1], assetInventory: true, syncDataSourceId: 1 },
        //{ id: 3, text: 'Phần mềm HTGTĐB', assetTypeGroupId: 22, assetTypeGroupIds: [22] },
        //{ id: 4, text: 'Phần mềm CTNS', assetTypeGroupId: 21, assetTypeGroupIds: [21] },
        //{ id: 5, text: 'Phần mềm KCHT đường sắt', assetTypeGroupId: 23, assetTypeGroupIds: [23] },
        //{ id: 6, text: 'Phần mềm KCHT thủy lợi', assetTypeGroupId: 24, assetTypeGroupIds: [24] },
        //{ id: 7, text: 'Phần mềm KCHT hàng không', assetTypeGroupId: 25, assetTypeGroupIds: [25] },
        //{ id: 8, text: 'Phần mềm KCHT hàng hải', assetTypeGroupId: 26, assetTypeGroupIds: [26] },
        //{ id: 9, text: 'Phần mềm KCHT giao thông đường thủy nội địa', assetTypeGroupId: 27, assetTypeGroupIds: [27] },
        //{ id: 10, text: 'Phần mềm KCHT khác', assetTypeGroupId: 28, assetTypeGroupIds: [28] },
        //{ id: 11, text: 'Phần mềm quản lý đất đai', assetTypeGroupId: 4, assetTypeGroupIds: [4] },
        //{ id: 12, text: 'Phần mềm quản lý tài nguyên', assetTypeGroupId: 5, assetTypeGroupIds: [5] },
        //{ id: 13, text: 'Phần mềm quản lý tài sản công tại doanh nghiệp', assetTypeGroupId: 6, assetTypeGroupIds: [6] }

    ],
    syncPrivilegeModules: [
        {
            code: 'sync_master_data',
            name: 'Đồng bộ thông tin danh mục',
            privileges: ['SyncMasterDataUnitType',
                'SyncMasterDataUnit',
                'SyncMasterDataIncreasementCause',
                'SyncMasterDataDecreasementCause',
                'SyncMasterDataAssetSource',
                'SyncMasterDataAssetUsageState',
                'SyncMasterDataAssetUsagePurpose',
                'SyncMasterDataCountry',
                'SyncMasterDataRegion',
                'SyncMasterDataAssetTypeTree',
                'SyncMasterDataUser',
                'SyncMasterDataUser',
                'SyncMasterDataAssetHandlingForm',
                'SyncMasterDataAssetHandlingMethod',
                'SyncMasterDataDepartment',
                'SyncMasterDataProject',
                'SyncMasterDataDepartment',
                'SyncMasterDataProject']
        },
        {
            code: 'sync_asset_mutation',
            name: 'Đồng bộ thông tin tài sản',
            privileges: ['SyncAssetMutationIncreasement',
                'SyncAssetMutationDecreasement',
                'SyncAssetMutationValueIncreasement',
                'SyncAssetMutationValueDecreasement',
                'SyncAssetMutationInformation',
                'SyncAssetMutationTransfer',
                'SyncAssetInvetory',
                'SyncAssetHandling',
                'SyncAssetDepreciation',
                'SyncAssetAmortization',
                'AssetExploitationLease',
                'AssetExploitationBusiness',
                'AssetExploitationVenture',
                'AssetExploitationOther',
                'SyncAssetExploitationForAmount',
                'SyncAssetNationalPublicAssetHandling',
                'SyncAssetNationalPublicAsset']
        },
        {
            code: 'sync_report',
            name: 'Đồng bộ báo cáo tài sản',
            privileges: ['SyncReport_08A_DK_TSC_01',
                'SyncReport_08A_DK_TSC_02',
                'SyncReport_08A_DK_TSC_03',
                'SyncReport_08B_DK_TSC_01',
                'SyncReport_08B_DK_TSC_02',
                'SyncReport_08B_DK_TSC_03',
                'SyncReport_09A_CK_TSC',
                'SyncReport_09B_CK_TSC',
                'SyncReport_09C_CK_TSC',
                'SyncReport_09D_CK_TSC',
                'SyncReport_09DD_CK_TSC',
                'SyncReport_10A_CK_TSC',
                'SyncReport_10B_CK_TSC',
                'SyncReport_10C_CK_TSC',
                'SyncReport_10D_CK_TSC',
                'SyncReport_11A_CK_TSC',
                'SyncReport_11B_CK_TSC',
                'SyncReport_11C_CK_TSC',
                'SyncReport_11D_CK_TSC',
                'SyncReport_08A_DK_TSKCHT_01',
                'SyncReport_08A_DK_TSKCHT_02',
                'SyncReport_08A_DK_TSKCHT_03',
                'SyncReport_08B_DK_TSKCHT_01',
                'SyncReport_08B_DK_TSKCHT_02',
                'SyncReport_08B_DK_TSKCHT_03',
                'SyncReport_08C_DK_TSKCHT_01',
                'SyncReport_08C_DK_TSKCHT_02',
                'SyncReport_08D_DK_TSKCHT',
                'SyncReport_BCCP_01',
                'SyncReport_BCCP_02',
                'SyncReport_BCCP_03',
                'SyncReport_BCCP_04',
                'SyncReport_BCCP_05',
                'SyncReport_BCCP_06',
                'SyncReport_BCCP_07',
                'SyncReport_BCCP_08',
                'SyncReport_BCCP_09',
                'SyncReport_BCCP_10',
                'SyncReport_BCCP_11A',
                'SyncReport_BCCP_11B',
                'SyncReport_BCTSCTKVHV',
                'SyncReport_B03_CCTT_A',
                'SyncReport_B03_CCTT_B',
                'SyncReport_XLSHTD_01',
                'SyncReport_XLSHTD_02',
                'SyncReport_XLSHTD_03',
                'SyncReport_XLSHTD_04',
                'SyncReport_XLSHTD_05',
                'SyncReport_XLSHTD_06']
        }
    ],
    listAccountingStandard: [
        { text: 'Hao mòn', id: 1 },
        { text: 'Khấu hao', id: 2 },
        { text: 'Cả hao mòn/ khấu hao', id: 3 },
    ],
    listAssetSourceGroup: [
        { text: "Tịch thu tài sản", id: 1 },
        { text: "Xác lập tài sản", id: 2 }
    ],
    listReportRequestStatuses: [
        { text: "Đã gửi yêu cầu ", id: 1 },
        { text: "Đã nhận báo cáo", id: 2 },
        { text: "Đã xảy ra lỗi khi gửi yêu cầu", id: 3 }
    ],
    listPeriodType: [
        { id: 1, text: "Báo cáo theo ngày" },
        { id: 2, text: "Báo cáo theo khoảng thời gian" },
        { id: 3, text: "Báo cáo theo năm" },
    ],
    listPeriodTypeReportYear: [
        { id: 1, text: "Năm trước" },
        { id: 2, text: "Năm hiện tại" },
    ],
    listAssetSourceByAssetTypeGroup: [],
    sidebarShow: 'responsive',
    sidebarOpeningItem: null
}

const getters = {
    setting: state => property => {
        return state.appSettings[property];
    },
    defaultUnitTreeOptions: (state, getters) => (syncSourceType) => {
        switch (parseInt(syncSourceType)) {
            case 1:
            case 101:
            case 102:
            case 2: return state.defaultUnitTreeOptions.filter(x => x.syncSourceType == 1 || x.syncSourceType == 2);
            default: return state.defaultUnitTreeOptions.filter(x => x.syncSourceType == syncSourceType);
        }
    },
    getAssetTypePath: (state, getters) => id => {
        var assetType = findNode(getters.assetTypeTreeFull, id);

        var path = [];
        while (assetType && (getters.assetTypeTreeFull.length > 1 || assetType.id > 0)) {
            path.push(assetType.label);

            assetType = findNode(getters.assetTypeTreeFull, assetType.parentId);
        }

        return path.join(', ');
    },
    getReportConstant: state => (value, options) => {
        var option = state.reportConstants[options].find(x => x.id == value);

        if (option) {
            return option.text;
        } else {
            return value;
        }
    },
    getAssetInfoSyncTypeName: state => typeId => {
        if (!isNaN(typeId)) {
            var item = state.listAssetInfoSyncTypes[typeId - 1];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getMasterDataSyncTypeName: state => typeId => {
        if (!isNaN(typeId)) {
            var item = state.listMasterDataSyncTypes[typeId - 1];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getReportSyncTypeName: state => typeId => {
        if (!isNaN(typeId)) {
            var item = state.listReportSyncTypes[typeId - 1];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getReportSyncTypeCode: state => typeId => {
        if (!isNaN(typeId)) {
            return state.listReportSyncTypes[typeId - 1].code;
        } else {
            return null;
        }
    },
    getReportSyncType: state => typeId => {
        if (!isNaN(typeId)) {
            return state.listReportSyncTypes[typeId - 1];
        } else {
            return null;
        }
    },
    getReportSyncTypeTitle: state => typeId => {
        if (!isNaN(typeId)) {
            var item = state.listReportSyncTypes[typeId - 1];
            return item ? item.title : "";
        } else {
            return "";
        }
    },
    getStatusName: state => statusId => {
        if (!isNaN(statusId)) {
            var item = state.listStatuses[statusId];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getActionName: state => actionId => {
        if (!isNaN(actionId)) {
            var item = state.listActions[actionId - 1];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getReportRequestStatusName: state => statusId => {
        if (!isNaN(statusId)) {
            var item = state.listReportRequestStatuses[statusId - 1];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getSyncSourceType: state => sourceId => {
        if (!isNaN(sourceId)) {
            var item = state.listSyncSourceTypes.find(x => x.id == sourceId);
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getGroupReportTypeName: state => reportGroupTypeId => {
        if (!isNaN(reportGroupTypeId)) {
            var item = state.listGroupReportTypes[reportGroupTypeId - 1];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getGroupReportTypeCode: state => reportGroupTypeId => {
        if (!isNaN(reportGroupTypeId)) {
            var item = state.listGroupReportTypes[reportGroupTypeId - 1];
            return item ? item.code : null;
        } else {
            return null;
        }
    },
    assetSourceTree: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var assetSources = state.assetSources.map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    normalizeText: x.name.latinize(),
                    parentId: x.parentId,
                    assetSourceGroup: x.assetSourceGroup,
                    appliedAssetTypeGroupIds: x.appliedAssetTypeGroupIds || undefined
                };
            });
            return BuildTree(assetSources);
        } else {
            return [];
        }
    },
    assetSourceTreeOrder: (state, getters, rootState) => (sortField, sortDirection) => {
        var tree = getters.assetSourceTree;

        if (sortField) {
            tree = sortTree(tree, sortField, sortDirection);
        }

        return tree;
    },
    assetTypeGroupTree: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var assetTypeGroups = state.assetTypeGroups.map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    parentId: x.parentId
                };
            });
            return BuildTree(assetTypeGroups);
        } else {
            return [];
        }
    },
    assetTypeGroupTreeByRoot: (state, getters, rootState) => (rootId) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var assetTypeGroups = state.assetTypeGroups.map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    parentId: x.parentId
                };
            });

            var tree = BuildTree(assetTypeGroups)

            if (rootId instanceof Array) {
                return rootId.map(root => findNode(tree, root));
            } else {
                var filter = findNode(tree, rootId);

                if (filter) {
                    return [filter]
                } else {
                    return [];
                }
            }
        } else {
            return [];
        }
    },
    unitTypeTree: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {

            var unitTypes = state.unitTypes.map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    normalizeText: x.name.latinize(),
                    parentId: x.parentId
                };
            });
            return BuildTree(unitTypes);
        } else {
            return [];
        }
    },
    unitTypeTreeOrder: (state, getters, rootState) => (sortField, sortDirection) => {
        var unitTypeTree = getters.unitTypeTree;

        if (sortField) {
            unitTypeTree = sortTree(unitTypeTree, sortField, sortDirection);
        }

        return unitTypeTree;
    },
    getUnitTypeTreeCode: state => id => {
        if (!isNaN(id)) {
            var item = state.unitTypes.find(x => x.id === id);
            return item ? item.code : null;
        } else {
            return null;
        }
    },
    assetTypeTree: (state, getters, rootState) => (treeId, groupId) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated && groupId) {
            var groups = [parseInt(groupId)];

            addChildGroup(state.assetTypeGroups.find(x => x.id == groupId));

            function addChildGroup(group) {
                var children = state.assetTypeGroups.filter(x => x.parentId == group.id);
                for (var i = 0; i < children.length; i++) {
                    groups.push(children[i].id);
                    addChildGroup(children[i]);
                }
            }

            var assetTypes = state.assetTypes.filter(x => groups.indexOf(x.assetTypeGroupId) != -1 && (treeId == null || x.treeId == treeId)).map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    normalizeText: x.name.latinize(),
                    parentId: x.parentId,
                    treeId: x.treeId,
                    assetTypeGroupId: x.assetTypeGroupId
                };
            });

            return BuildTree(assetTypes);
        } else {
            return [];
        }
    },
    assetTypeTreeOrder: (state, getters, rootState) => (treeId, groupId) => (sortField, sortDirection) => {
        var result = getters.assetTypeTree(treeId, groupId);

        result = sortTree(result, sortField, sortDirection);

        return result;
    },
    assetTypeTreeLevel1: (state, getters, rootState) => (treeId, groupId) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var assetTypes = state.assetTypes.filter(x => x.assetTypeGroupId == groupId && x.treeId == treeId && x.parentId == null).map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    parentId: x.parentId,
                    treeId: x.treeId,
                    assetTypeGroupId: x.assetTypeGroupId
                };
            });

            return _.orderBy(BuildTree(assetTypes), ['assetTypeGroupId'], ['asc']);
        } else {
            return [];
        }
    },
    assetTypeTreeByGroupIds: (state, getters, rootState) => (groupIds) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var assetTypes = state.assetTypes.filter(x => groupIds.indexOf(x.assetTypeGroupId) != -1).map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    parentId: x.parentId,
                    treeId: x.treeId,
                    assetTypeGroupId: x.assetTypeGroupId
                };
            });

            for (var i = 0; i < assetTypes.length; i++) {
                if (assetTypes[i].parentId != null && assetTypes.find(x => x.id == assetTypes[i].parentId) == null) {
                    assetTypes[i].parentId = null;
                }
            }

            return _.orderBy(BuildTree(assetTypes), ['assetTypeGroupId'], ['asc']);
        } else {
            return [];
        }
    },
    assetTypeTreeFull: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var assetTypes = state.assetTypes.map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    parentId: x.parentId,
                    treeId: x.treeId,
                    assetTypeGroupId: x.assetTypeGroupId
                };
            });

            return _.orderBy(BuildTree(assetTypes), ['assetTypeGroupId'], ['asc']);
        } else {
            return [];
        }
    },
    //quyetpt: build tree Tài sản xác lập sở hữu toàn dân
    assetTypeTreeByAssetTypeGroupId: (state, getters, rootState) => (assetTypeGroupId) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var groups = [parseInt(assetTypeGroupId)];

            addChildGroup(state.assetTypeGroups.find(x => x.id == assetTypeGroupId));

            function addChildGroup(group) {
                var children = state.assetTypeGroups.filter(x => x.parentId == group.id);

                for (var i = 0; i < children.length; i++) {
                    groups.push(children[i].id);
                    addChildGroup(children[i]);
                }
            }

            var assetTypes = state.assetTypes.filter(x => groups.indexOf(x.assetTypeGroupId) != -1).map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    parentId: x.parentId,
                    treeId: x.treeId,
                    assetTypeGroupId: x.assetTypeGroupId
                };
            });

            return _.orderBy(BuildTree(assetTypes), ['assetTypeGroupId'], ['asc']);
        } else {
            return [];
        }
    },
    //nhóm tài sản
    //assetTypeTreeLevel2: (state, getters, rootState) => {
    //    var isAuthenticated = rootState.identity.isAuthenticated;
    //    if (isAuthenticated) {
    //        var assetTypeTrees = state.assetTypeTrees;

    //        if (assetTypeTrees.length == 0) return [];

    //        var assetTypes = state.assetTypes.map(x => {
    //            return {
    //                id: x.id,
    //                code: x.code,
    //                label: x.name,
    //                parentId: x.parentId == null ? -x.treeId : x.parentId,
    //                treeId: x.treeId
    //            };
    //        });

    //        var tree = [];

    //        var groups = _.groupBy(assetTypes, x => x.treeId);

    //        for (var g in groups) {
    //            var assetTypeTree = assetTypeTrees.find(x => x.id == groups[g][0].treeId);
    //            if (assetTypeTree) {
    //                var root = {
    //                    id: -assetTypeTree.id,
    //                    label: assetTypeTree.text,
    //                    parentId: null
    //                };

    //                tree.push(BuildTree([root].concat(groups[g]), 3)[0]);
    //            }
    //        }

    //        if (tree.length == 1) {
    //            tree = tree[0].children || [];
    //        }

    //        return tree;
    //    } else {
    //        return [];
    //    }
    //},
    //build loại tài sản - báo cáo sở hữu toàn dân
    nationalAssetTypeTree: (state, getters, rootState) => (level) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var nationalAssetTypes = state.listNationalAssetType.map(x => {
                return {
                    id: x.id,
                    label: x.name,
                    parentId: x.parentId
                };
            });
            return BuildTree(nationalAssetTypes, level);
        } else {
            return [];
        }
    },
    regionTree: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            var regions = state.regions.map(x => {
                return {
                    id: x.id,
                    code: x.code,
                    label: x.name,
                    hasChildren: x.hasChildren,
                    parentId: x.parentId,
                };
            });
            return BuildTree(regions);
        } else {
            return [];
        }
    },
    buildDepartmentTree: (state, getters, rootState) => (departments, sortField, sortDirection) => {
        var result = departments.map(x => {
            return {
                id: x.id,
                code: x.code,
                label: x.name,
                normalizeText: x.name.latinize(),
                hasChildren: x.hasChildren,
                parentId: x.parentId,
                isActive: x.isActive
            };
        });

        return BuildTree(result);
    },
    getDepartmentTreeCode: state => (departments, id) => {
        if (!isNaN(id)) {
            var item = findNode(departments, id);
            return item ? item.code : null;
        } else {
            return null;
        }
    },
    //cây phân loại tài sản
    listAssetTypeTrees: (state, getters, rootState) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            return state.assetTypeTrees;
        } else {
            return [];
        }
    },
    getAssetTypeByTreeId: (state, getters, rootState) => (treeId, level) => {
        var isAuthenticated = rootState.identity.isAuthenticated;
        if (isAuthenticated) {
            if (treeId) {
                var assetTypes = state.assetTypes.filter(x => x.treeId == treeId).map(x => {
                    return {
                        id: x.id,
                        code: x.code,
                        label: x.name,
                        parentId: x.parentId
                    };
                });
                return BuildTree(assetTypes, level);
            }
            return [];
        } else {
            return [];
        }
    },
    getAssetTypeByTreeCode: state => (id) => {
        if (!isNaN(id)) {
            //var item = departments.find(x => x.id === id);
            var item = findNode(state.assetTypes, id);
            return item;
        } else {
            return null;
        }
    },
    getAssetSourceTreeCode: state => (id) => {
        if (!isNaN(id)) {
            var item = state.assetSources.find(x => x.id === id);
            return item ? item.code : null;
        } else {
            return null;
        }
    },
    getRegionCode: state => (id) => {
        if (!isNaN(id)) {
            var item = state.regions.find(x => x.id === id);
            return item ? item.code : null;
        } else {
            return null;
        }
    },
    //kiểm tra trùng tên nhóm tài sản cha
    checkExistingAssetTypeName: (state) => (id, treeId, parentId, name) => {
        var item = {};
        if (id) {
            item = state.assetTypes.filter(assetType => treeId == assetType.treeId && assetType.id != id && assetType.parentId == (parentId ? parentId : null) && assetType.name.latinize().toLowerCase().trim() == name.latinize().toLowerCase().trim());
        } else {
            item = state.assetTypes.filter(assetType => treeId == assetType.treeId && assetType.parentId == (parentId ? parentId : null) && assetType.name.latinize().toLowerCase().trim() == name.latinize().toLowerCase().trim());
        }
        if (item.length > 0) return true;
        return false;
    },
    ListAssetCategory: (state) => {
        return state.assetCategories;
    },
    getAssetSourceGroupName: state => assetSourceGroupId => {
        if (!isNaN(assetSourceGroupId)) {
            var item = state.listAssetSourceGroup[assetSourceGroupId - 1];
            return item ? item.text : null;
        } else {
            return null;
        }
    },
    getTreeReportByReportType: (state) => {
        var reportTypes = state.listGroupReportTypes;
        var reports = state.listReportSyncTypes;
        var arr = [];
        for (var i = 0; i < reportTypes.length; i++) {
            var node = reportTypes[i];
            arr.push(
                {
                    id: "1000" + node.id,
                    label: node.text,
                    code: node.code,
                    parentId: undefined,
                });
            for (var j = 0; j < node.reportTypeIds.length; j++) {
                var report = reports.find(x => x.id == node.reportTypeIds[j]);
                arr.push({
                    id: report.id,
                    label: report.title,
                    code: report.code,
                    parentId: "1000" + node.id
                });
            }
        }
        return BuildTree(arr);
    },
    getTreeReportByReportTypes: (state) => (data) => {
        var reportTypes = [...state.listGroupReportTypes];
        var reports = [...state.listReportSyncTypes.filter(x => data.indexOf(x.id) != -1)];
        var arr = [];
        for (var i = 0; i < reportTypes.length; i++) {
            var node = reportTypes[i];
            var isExist = node.reportTypeIds.filter(x => data.indexOf(x) != -1);
            if (isExist.length > 0) {
                arr.push(
                    {
                        id: "1000" + node.id,
                        label: node.text,
                        code: node.code,
                        parentId: undefined,
                    });
            }
            for (var j = 0; j < node.reportTypeIds.length; j++) {
                var report = reports.find(x => x.id == node.reportTypeIds[j]);
                if (report) {
                    arr.push({
                        id: report.id,
                        label: report.title,
                        code: report.code,
                        parentId: "1000" + node.id
                    });
                }
            }
        }
        return BuildTree(arr);
    },
    getReportRequestLoginUsers: state => syncDataSourceId => {
        var item = state.reportRequestLoginUsers.map(x => {
            return {
                id: x.id,
                text: x.userName,
                value: x.id,
                syncDataSourceId: x.syncDataSourceId
            }
        });
        return item;
    },
    getSyncDataSources: state => {
        var item = state.syncDataSources;
        return item;
    },
    getPeriodTypes: state => index => {
        var item = state.listPeriodType[index - 1];
        return item ? item.text : '';
    },
    getPeriodTypeReportYears: state => index => {
        var item = state.listPeriodTypeReportYear[index - 1];
        return item ? item.text : '';
    },
}

const actions = {
    updateBreadcrumb(context) {
        context.commit('updateBreadcrumb');
    },
    loadTopLevelUnits(context) {
        return Services.get(`lookup/units/top-level`, null, { showLoading: false }).done((response) => {
            context.commit('setTopLevelUnits', response);
        });
    },
    loadDefaultUnitTreeOptions(context) {
        return Services.get(`lookup/units/root?includeInactive=false`, null, { showLoading: false }).done((response) => {
            context.commit('setDefaultUnitTreeOptions', response);
        });
    },
    loadPrivileges(context) {
        return Services.get('lookup/privileges').done((data) => {
            context.commit('setPrivileges', data);
        });
    },
    loadSyncPrivileges(context) {
        return Services.get('lookup/sync-privileges').done((data) => {
            context.commit('setSyncPrivileges', data);
        });
    },
    loadAssetTypes(context) {
        return Services.get(`lookup/asset-types`).done((data) => {
            context.commit('setAssetTypes', data);
        });
    },
    loadAssetSources(context) {
        return Services.get(`lookup/asset-sources`).done((data) => {
            context.commit('setAssetSources', data);
        });
    },
    loadUnitTypes(context) {
        return Services.get(`lookup/unit-types`).done((data) => {
            context.commit('setUnitTypes', data);
        });
    },
    //loadAssetTypesByTreeId(context, treeId) {
    //    return Services.get(`lookup/asset-types/${treeId}/list`).done((data) => {
    //        context.commit('setAssetTypes', data);
    //    });
    //},
    loadAssetMutationTypes(context) {
        return Services.get('lookup/asset-mutation-types').done((data) => {
            context.commit('setAssetMutationTypes', data);
        });
    },
    loadAssetMutationCauseTypes(context) {
        return Services.get('lookup/asset-mutation-cause-types').done((data) => {
            context.commit('setAssetMutationCauseTypes', data);
        });
    },
    loadUnitLevel(context) {
        return Services.get('lookup/unit-levels').done((data) => {
            context.commit('setUnitLevel', data);
        });
    },
    loadUnitLevelCentral(context) {
        return Services.get('lookup/unit-levels-central').done((data) => {
            context.commit('setUnitLevelCentral', data);
        });
    },
    loadUnitLevelLocal(context) {
        return Services.get('lookup/unit-levels-local').done((data) => {
            context.commit('setUnitLevelLocal', data);
        });
    },
    loadRegions(context) {
        return Services.get('lookup/regions').done((data) => {
            context.commit('setRegions', data);
        });
    },
    loadAssetCategory(context) {
        var data = {
            // tài sản công - đất
            NPA_LAND: "NpaLand",
            // tài sản công - nhà
            NPA_HOUSE: "NpaHouse",
            // tài sản công - xe
            NPA_VEHICLE: "NpaVehicle",
            /// tài sản công - khác
            NPA_OTHER: "NpaOther",
            /// tài sản toàn dân - đất
            OA_LAND: "OaLand",
            /// tài sản toàn dân - nhà
            OA_HOUSE: "OaHouse",
            /// tài sản toàn dân - xe
            OA_VEHICLE: "OaVehicle",
            /// tài sản toàn dân - trên 500M
            OA_ABOVE_500M: "OaAbove500M",
            /// tài sản toàn dân - dưới 500M
            OA_BELOW_500M: "OaBelow500M"
        };
        var data2 = [
            "NpaLand",// tài sản công - đất
            "NpaHouse",// tài sản công - nhà
            "NpaVehicle", // tài sản công - xe
            "NpaOther",// tài sản công - khác
            "OaLand",// tài sản toàn dân - đất
            "OaHouse",// tài sản toàn dân - nhà
            "OaVehicle",// tài sản toàn dân - xe
            "OaAbove500M",// tài sản toàn dân - trên 500M
            "OaBelow500M"// tài sản toàn dân - dưới 500M
        ];
        return context.commit('setAssetCategory', data);
    },
    loadReportConstants(context) {
        return Services.get('lookup/report-constants').done((data) => {
            context.commit('setReportConstants', data);
        });
    },
    loadTableComments(context) {
        return Services.get('lookup/table-comments', null, { async: false }).done((data) => {
            context.commit('setTableComments', data);
        });
    },
    loadAssetComments(context) {
        return Services.get('lookup/asset-comments').done((data) => {
            context.commit('setAssetComments', data);
        });
    },
    loadAssetTypeTrees(context) {
        return Services.get('lookup/asset-type-trees').done((data) => {
            context.commit('setAssetTypeTrees', data);
        });
    },
    //loadAssetModules(context) {
    //    return Services.get('lookup/asset-modules').done((data) => {
    //        context.commit('setAssetModules', data);
    //    });
    //},
    loadAssetTypeGroups(context) {
        return Services.get('lookup/asset-type-groups').done((data) => {
            context.commit('setAssetTypeGroups', data);
        });
    },
    loadNationalAssetTypeByOrigin(context) {
        return Services.get('lookup/national-asset-type-by-origin').done((data) => {
            context.commit('setNationalAssetTypeByOrigin', data);
        });
    },
    initializeSettings(context) {
        return new Promise((resolve, reject) => {
            if (!context.state.isInitialized) {
                Services.get('lookup/initialize').done((data) => {
                    context.commit('setTopLevelUnits', data.topLevelUnits);
                    context.commit('setDefaultUnitTreeOptions', data.defaultUnitTreeOptions);
                    context.commit('setPrivileges', data.privileges);
                    context.commit('setSyncPrivileges', data.syncPrivileges);
                    context.commit('setAssetTypes', data.assetTypes);
                    context.commit('setAssetSources', data.assetSources);
                    context.commit('setUnitTypes', data.unitTypes);
                    context.commit('setAssetMutationCauseTypes', data.assetMutationCauseTypes);
                    context.commit('setAssetMutationCauses', data.assetMutationCauses);
                    context.commit('setAssetMutationTypes', data.assetMutationTypes);
                    context.commit('setUnitLevel', data.unitLevel);
                    context.commit('setUnitLevelCentral', data.unitLevelCentral);
                    context.commit('setUnitLevelLocal', data.unitLevelLocal);
                    context.commit('setRegions', data.regions);
                    context.dispatch('loadAssetCategory');
                    context.commit('setReportConstants', data.reportConstants);
                    context.commit('setTableComments', data.tableComments);
                    context.commit('setAssetComments', data.assetComments);
                    context.commit('setAssetTypeTrees', data.assetTypeTrees);
                    context.commit('setAssetTypeGroups', data.assetTypeGroups);
                    context.commit('setNationalAssetTypeByOrigin', data.nationalAssetTypeByOrigin);
                    context.commit('setReportRequestLoginUsers', data.reportRequestLoginUsers);
                    context.commit('setSyncDataSources', data.syncDataSources);
                    context.commit('setSyncSourceTypes', data.syncSourceTypes);

                    context.commit('initialize');
                    resolve(true);
                }).fail(() => {
                    resolve(false);
                });


                //context.dispatch('loadTopLevelUnits');
                //context.dispatch('loadDefaultUnitTreeOptions');
                //context.dispatch('loadPrivileges');
                //context.dispatch('loadSyncPrivileges');
                //context.dispatch('loadAssetTypes');
                //context.dispatch('loadAssetSources');
                //context.dispatch('loadUnitTypes');
                //context.dispatch('loadAssetMutationTypes');
                //context.dispatch('loadAssetMutationCauseTypes');
                //context.dispatch('loadUnitLevel');
                //context.dispatch('loadUnitLevelCentral');
                //context.dispatch('loadUnitLevelLocal');
                //context.dispatch('loadRegions');
                //context.dispatch('loadAssetCategory');
                //context.dispatch('loadReportConstants');
                //context.dispatch('loadTableComments');
                //context.dispatch('loadAssetComments');
                //context.dispatch('loadAssetTypeTrees');
                ////context.dispatch('loadAssetModules');
                //context.dispatch('loadAssetTypeGroups');
                //context.dispatch('loadNationalAssetTypeByOrigin');
            } else {
                resolve(true);
            }
        });
    }
}

// mutations
const mutations = {
    initialize(state) {
        state.isInitialized = true;
    },
    updateBreadcrumb(state) {
        state.updateBreadcrumbCount++;
    },
    setTopLevelUnits(state, options) {
        state.topLevelUnits = options;
    },
    setDefaultUnitTreeOptions(state, options) {
        state.defaultUnitTreeOptions = options;
    },
    setPrivileges(state, privileges) {
        state.privileges = privileges;
    },
    setSyncPrivileges(state, syncPrivileges) {
        state.syncPrivileges = syncPrivileges;
    },
    setAssetTypes(state, data) {
        state.assetTypes = data;
    },
    setAssetSources(state, data) {
        state.assetSources = data;
    },
    setUnitTypes(state, data) {
        state.unitTypes = data;
    },
    setAssetMutationTypes(state, data) {
        state.assetMutationTypes = data;
    },
    setAssetMutationCauses(state, data) {
        state.assetMutationCauses = data;
    },
    setAssetMutationCauseTypes(state, data) {
        state.assetMutationCauseTypes = data;
    },
    setUnitLevel(state, data) {
        state.unitLevels = data;
    },
    setUnitLevelCentral(state, data) {
        state.unitLevelsCentral = data;
    },
    setUnitLevelLocal(state, data) {
        state.unitLevelsLocal = data;
    },
    setRegions(state, data) {
        state.regions = data;
    },
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    },
    setAssetCategory(state, data) {
        state.assetCategories = data;
    },
    setReportConstants(state, data) {
        state.reportConstants = data;
    },
    setTableComments(state, data) {
        state.tableComments = data;
    },
    setAssetComments(state, data) {
        state.assetComments = data;
    },
    setAssetTypeTrees(state, data) {
        state.assetTypeTrees = data;
    },
    //setAssetModules(state, data) {
    //    state.assetModules = data;
    //},
    setAssetTypeGroups(state, data) {
        state.assetTypeGroups = data;
    },
    setNationalAssetTypeByOrigin(state, data) {
        state.listNationalAssetType = data;
    },
    setReportRequestLoginUsers(state, data) {
        state.reportRequestLoginUsers = data;
    },
    setSyncDataSources(state, data) {
        state.syncDataSources = data;
    },
    setSyncSourceTypes(state, data) {
        state.listSyncSourceTypes = data;
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}


function BuildUnitTree(allUnits, root) {
    var tree = [];

    var path = [];

    for (var i = 0; i < allUnits.length; i++) {
        var currentNode = allUnits[i];
        if (root) {
            if (currentNode.id == root) {
                path.push(currentNode);
                tree.push(currentNode);
                continue;
            }
        } else {
            if (!currentNode.parentId) {
                path = [];
                path.push(currentNode);
                tree.push(currentNode);
                continue;
            }
        }

        while (path.length > 0) {
            var parentNode = path[path.length - 1];
            if (currentNode.parentId == parentNode.id) {
                currentNode.parent = parentNode;
                if (!parentNode.children) parentNode.children = [];
                parentNode.children.push(currentNode);
                path.push(currentNode);
                break;
            }
            path.pop();
        }
    }

    return tree;
}

function BuildAssetTypeTree(allNodes, level = 999) {
    var tree = [];
    var path = [];
    for (var i = 0; i < allNodes.length; i++) {
        var currentNode = allNodes[i];

        if (!currentNode.parentId) {
            path = [];
            path.push(currentNode);
            tree.push(currentNode);
            continue;
        }

        while (path.length > 0) {
            var parentNode = path[path.length - 1];
            if (currentNode.parentId == parentNode.id) {
                //currentNode.parent = parentNode;
                path.push(currentNode);
                if (path.length > level) {
                    break;
                }
                if (!parentNode.children) parentNode.children = [];
                parentNode.children.push(currentNode);
                break;
            }
            path.pop();
        }
    }
    //console.log(tree);
    return tree;
}

function BuildTree(allNodes, level = 999) {
    var tree = [];
    var path = [];
    for (var i = 0; i < allNodes.length; i++) {
        var currentNode = allNodes[i];

        if (!currentNode.parentId) {
            path = [];
            path.push(currentNode);
            tree.push(currentNode);
            continue;
        }

        while (path.length > 0) {
            var parentNode = path[path.length - 1];
            if (currentNode.parentId == parentNode.id) {
                //currentNode.parent = parentNode;
                path.push(currentNode);
                if (path.length > level) {
                    break;
                }
                if (!parentNode.children) parentNode.children = [];
                parentNode.children.push(currentNode);
                break;
            }
            path.pop();
        }
    }
    //console.log(tree);
    return tree;
}

function findNode(tree, id) {
    for (var i = 0; i < tree.length; i++) {
        if (tree[i].id == id) {
            return tree[i];
        } else if (tree[i].children && tree[i].children.length > 0) {
            var found = findNode(tree[i].children, id);

            if (found) return found;
        }
    }

    return null;
}

function sortTree(tree, sortField, sortDirection) {

    tree = _.orderBy(tree, [sortField], [sortDirection]);

    for (var i = 0; i < tree.length; i++) {
        if (tree[i].children && tree[i].children.length > 0) {
            tree[i].children = sortTree(tree[i].children, sortField, sortDirection)
        }
    }

    return tree;
}